import { initializeIcons } from "@fluentui/react";
import {
	ThemeProvider as NextThemesProvider,
	type ThemeProviderProps,
} from "next-themes";
import { useEffect } from "react";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
	useEffect(() => {
		initializeIcons();
	}, []);
	return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
